/**
 * Preload non-critical stylesheets after initial render
 * Called from main.tsx after the app mounts
 */
export const preloadNonCriticalStyles = () => {
  // Use requestIdleCallback to load during idle time
  /* eslint-disable @aix/no-inline-dynamic-imports -- intentional lazy CSS loading for perf */
  const loadStyles = () => {
    void import("./aix-react-flow-style.css")
    void import("./crisp-chatbox.css")
    void import("./react-big-calendar.css")
    void import("react-big-calendar/lib/addons/dragAndDrop/styles.css")
    void import("react-photo-view/dist/react-photo-view.css")
  }
  /* eslint-enable @aix/no-inline-dynamic-imports */

  if (typeof window !== "undefined") {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(loadStyles, { timeout: 3000 })
    } else {
      // Fallback for Safari
      setTimeout(loadStyles, 1500)
    }
  }
}
